<template>
    <div class="box" v-if="selectProjMemberModels.isShow">
        <div class="mask-box" @click.stop.prevent="cancel"></div>
        <div class="querter-box">
            <div class="querter-list-box">
                <h4 style="margin:20px 0;width:270px"><i></i>选择项目成员
                    <input type="text" style="float:right;height:28px;border:1px solid #e7e7e7;padding-left:10px;font-size:12px" placeholder="搜索">
                </h4>
                <div class="item-box">
                    <ul>
                        <li v-for="(item, index) in RoleList" :key="index">
                            <img src="../../assets/common/last.png" alt="">
                            <span>{{item.userName}}</span>
                            <img src="../../assets/administrationIcon/active.png" class="checked-icon" v-if="item.active" @click.stop.prevent="checked(item)" alt="">
                            <img src="../../assets/administrationIcon/defult.png" class="checked-icon" v-if="!item.active" @click.stop.prevent="checked(item)" alt="">
                        </li>
                    </ul>
                </div>
            </div>
            <div class="select-list">
                <h4 style="margin:20px 0;width:100%"><i></i>已选项目成员</h4>
                <div class="item-box" style="border:0 none;">
                    <el-table ref="multipleTable" :data="selectList" :stripe="true" style="width: 100%"
                  :header-row-style="{background:fontColor,overflow:'hidden',}"  border
                  :row-style="{overflow:'hidden',}" :cell-style="{textAlign:'center',}" height="460"
                  :header-cell-style="{background:fontColor,height:'34px',padding:0,textAlign:'center'}"
                  >
                    <el-table-column  fixed label="项目成员" >
                        <template slot-scope="scope">
                            <p>{{scope.row.userName}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column  fixed label="操作" >
                         <template slot-scope="scope">
                            <button style="width:46px;height:22px;background: #FF6363;border-radius: 4px;color:#fff" @click="cancelSelect(scope.row)">一</button>
                        </template>
                    </el-table-column>
                    </el-table>

                </div>
            </div>
            <div class="footer">
                <el-button @click="cancel" size="small">关闭</el-button>
                <el-button type="warning" size="small" @click="success">确定</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import {util} from '@/utils/utils'
import {mapGetters} from 'vuex'
export default {
  props: ['selectProjMemberModels'],
  data () {
    return {
      active: false,
      dialogVisible: false,
      level: 0,
      selectList: [],
      RoleList: [],
      projectList: []
    }
  },
  created () {
    this.bgColor = this.$store.state.themeColor
    this.fontColor = this.$store.state.themeBG
    this.selectList = this.selectProjMemberModels.selectList
    this.loadData()
  },
  beforeDestroy () {
  },
  computed: {
    ...mapGetters([
      'getFormConfig'
    ])
  },
  methods: {
    loadData () {
      let _this = this
      let params = {
        formKey: 't_proj_qx',
        id: 'T_PROJ_POWER_1',
        pageIndex: 1,
        pageSize: 2147483647
      }
      // 先判断传入数据
      if (this.selectProjMemberModels.projId) {
        params.sessionProj = {
          projId: this.selectProjMemberModels.projId,
          projUid: this.selectProjMemberModels.projId
        }
      } else {
        let sessionProj = null
        if (window.localStorage.getItem('_session_proj' + _this.sessionUtil.getUser().id)) {
          sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + _this.sessionUtil.getUser().id))
        } else if (_this.getFormConfig && _this.getFormConfig['_session_proj' + _this.sessionUtil.getUser().id]) {
          sessionProj = _this.getFormConfig['_session_proj' + _this.sessionUtil.getUser().id].data
        }
        if (sessionProj) {
          params.sessionProj = {
            projId: sessionProj.PROJ_ID_,
            projUid: sessionProj.PROJ_UID_
          }
        }
      }
      // 如果没有携带projctId 则无法选择
      if (!params.sessionProj) {
        return
      }
      util.restPost('/api_v1/form/data_list', params, res => {
        if (res.status == 200) {
          this.RoleList = res.data.map(item => {
            item.id = item.USER_UID_
            item.userName = item.USER_UID_LABEL_
            item.picture = item.USER_UID_PICTURE_
            return item
          })
          this.toggleSelection(this.selectList)
        } else {
          this.util.error(res.msg)
        }
      })
    },
    // 切换选择状态
    toggleSelection (rows) {
      if (rows) {
        this.RoleList.map(item => {
          let user = rows.find(row => row.userName === item.userName)
          if (user) item.active = true
          return item
        })
      } else {
        this.$refs.quertPeopleTable.clearSelection()
      }
    },
    checked (node) {
      node.active = !node.active
      if (node.active) {
        this.selectList.push(node)
      } else {
        this.deleteRepeat(this.selectList, node)
      }
    },
    deleteRepeat (arr, node) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == node.id) {
          arr.splice(i, 1)
        }
      }
    },
    cancel () {
      this.$store.state.selectProjectNode = {}
      this.selectProjMemberModels.isShow = false
    },
    cancelSelect (data) {
      data.active = false
      this.RoleList.map(row => {
        if (row.userName === data.userName) {
          row.active = false
        }
      })
      this.deleteRepeat(this.selectList, data)
      this.$forceUpdate()
    },
    success () {
      this.selectProjMemberModels.selectList = this.selectList
      this.selectProjMemberModels.callBack()
      this.cancel()
    }
  }
}
</script>
<style scoped>

.mask-box{
    width: 100%;height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
}
.querter-box{
    transform: translate(-50%,-50%);
    position: fixed;
    left: 50%;
    top: 50%;
    background: #fff;
    border-radius: 5px ;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    height: 600px;
    z-index: 999;
    overflow: hidden;
}
.querter-list-box{
    width: 320px;
    height: 100%;
    box-sizing: border-box;
    padding:68px 20px 70px;
    overflow: hidden;
    float: left;
}
.querter-list-box h4{
    position: absolute;
    left: 20px;
    top:0px;
}
.footer{
    position: absolute;
    bottom: 20px;
    right: 20px;
}
.item-box{
    width: 100%;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    overflow: auto;
    border: 1px solid #E7E7E7;
}
.select-list{
    width: 252px;
    height: 100%;
    float: left;
    padding: 68px 20px 70px;
    box-sizing: border-box;
    position: relative;
}
.select-list h4{
    position: absolute;
    left: 20px;
    top: 0;
}
img{
    vertical-align: middle;
}
.item-box li{
    padding:10px 20px;
}
.item-box li .checked-icon{
    width: 16px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/common/select-project-member/select-project-member.vue